import { minBy, uniqBy } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import api from "../config/api";
import { getEmployees } from "../stores/EmployeeStore";
import { useQuery } from "@tanstack/react-query";

export default function useEmployees() {
  const { data: employees } = useQuery({
    queryFn: getEmployees,
    queryKey: ["employees"],
  });

  var enumerateDaysBetweenDates = function (startDate, endDate) {
    var dates = [];

    var currDate = moment(startDate).startOf("day");
    var lastDate = moment(endDate).startOf("day");

    while (currDate.add(1, "days").diff(lastDate) < 0) {
      console.log(currDate.toDate());
      dates.push(currDate.clone().toDate());
    }
    return dates;
  };

  const availableDates = ({ startDate }) => {
    const dates = [];
    employees?.forEach((emp) => {
      const availability = emp.availability;
      availability.forEach((av) => {
        const availableDate = moment(startDate).startOf("isoWeek").day(av.day);
        const availableTimes = av.times;
        availableTimes.forEach((avt) => {
          dates.push({
            from: moment(
              `${moment(availableDate).format("DD/MM/YYYY")} ${avt.from.time}`,
              "DD/MM/YYYY hh:mma"
            ).toDate(),
            to: moment(
              `${moment(availableDate).format("DD/MM/YYYY")} ${avt.to.time}`,
              "DD/MM/YYYY hh:mma"
            ).toDate(),
            employee: emp,
          });
        });
      });
    });

    return dates;
  };

  const removeScheduledTasks = ({ avDates, formStartTime, formEndTime }) => {
    const dates = [];
    const employees = uniqBy(
      avDates.map((i) => i.employee),
      (i) => i._id
    );
    const tasks = [];
    employees?.map((i) => tasks.push(...i.tasks));

    avDates.forEach((li) => {
      const currentDate = moment(li.from).format("DD/MM/YYYY");
      const checkFrom = moment(
        `${currentDate} ${formStartTime.time}`,
        "DD/MM/YYYY hh:mma"
      ).toDate();
      const checkTo = moment(
        `${currentDate} ${formEndTime.time}`,
        "DD/MM/YYYY hh:mma"
      ).toDate();

      const currentTasks = tasks.filter((i) => {
        return moment(i.date).format("DD/MM/YYYY") === currentDate;
      });

      if (currentTasks.length === 0) return dates.push(li);
      const tsk = currentTasks.reverse()[0];
      const taskStart = moment(
        `${moment(tsk.date).format("DD/MM/YYYY")} ${tsk.startTime}`,
        "DD/MM/YYYY hh:mma"
      ).toDate();
      const taskEnd = moment(
        `${moment(tsk.date).format("DD/MM/YYYY")} ${tsk.endTime}`,
        "DD/MM/YYYY hh:mma"
      ).toDate();

      if (checkTo <= taskStart || checkFrom >= taskEnd) {
        dates.push(li);
      }
    });

    return dates;
  };

  const availableEmployees = ({
    dateList = [],
    formStartTime,
    formEndTime,
    addedSlots = [],
  }) => {
    const from = minBy(dateList.map((i) => new Date(i.from)));
    // Check whether time is available
    var avDates = availableDates({ startDate: from });

    // Check whether if task is schedule for the timeslot
    avDates = removeScheduledTasks({ avDates, formStartTime, formEndTime });

    const available = [...addedSlots];
    dateList.forEach((li) => {
      const slot = avDates.filter((i) => {
        return (
          new Date(i.from) <= new Date(li.from) &&
          new Date(i.to) >= new Date(li.to)
        );
      });

      if (slot) available.push(...slot);
    });

    return Object.values(uniqBy(available, (i) => i.employee._id));
  };

  return {
    enumerateDaysBetweenDates,
    employees,
    availableEmployees,
  };
}
